import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/lib/sentry";

// Fire-and-forget — fetches /api/public-sentry-config and calls Sentry.init
// if a DSN is present. Errors thrown during initial render are still caught
// by ErrorBoundary; init resolves moments later and subsequent events ship.
initSentry();

function GlobalErrorFallback({ error, resetError }) {
  return (
    <div
      data-testid="global-error-fallback"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <div style={{ maxWidth: 480, textAlign: "center" }}>
        <h1 style={{ fontSize: 24, marginBottom: 8 }}>Something went wrong</h1>
        <p style={{ color: "#54607A", marginBottom: 16 }}>
          The page hit an unexpected error. Our team has been notified.
        </p>
        <pre
          style={{
            background: "#FEF2F2",
            color: "#B91C1C",
            padding: "8px 12px",
            borderRadius: 6,
            fontSize: 12,
            textAlign: "left",
            overflow: "auto",
            marginBottom: 16,
          }}
        >
          {error?.message || String(error)}
        </pre>
        <button
          data-testid="global-error-reset"
          onClick={resetError}
          style={{
            background: "#004AE6",
            color: "white",
            border: 0,
            padding: "10px 20px",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Try again
        </button>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <GlobalErrorFallback error={error} resetError={resetError} />
      )}
      beforeCapture={(scope) => scope.setTag("boundary", "root")}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
